import React, { useState, useEffect } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { ListSubheader } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import { setCGState } from "../customerGroupSetupSlice";

const CreateMultiSelectCustCountry = () => {
  let { customerCountries, selCustCountries } = useSelector(
    (store) => store.customerGroupSetup
  );
  const dispatch = useDispatch();
  // console.log(customerCountries);
  let countries = customerCountries?.map((item) => item.countryName);
  // console.log(countries);
  countries = countries?.filter((item) => item !== "All");
  // console.log(countries);
  const [displayItem, setDisplayItem] = React.useState(
    customerCountries?.length - 1
  );
  const [searchText, setSearchText] = React.useState("");
  const [namesData, setNamesData] = React.useState([]);
  const textInput = React.useRef(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const state = useSelector((store) => store.analyze);

  const { selectedproducts, clearDataValues } = state;

  const handleChange = (e, name) => {
    let items = [...selCustCountries];

    if (e.target.checked) items.push(name);
    else {
      var index = items.indexOf(name);
      items.splice(index, 1);
    }		
    dispatch(setCGState("selCustCountries", items));
    let itemcount = items.length;
    setDisplayItem(itemcount);
    if (itemcount === 0) {
      setSelectAll(false);
    }
    if (itemcount === countries.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  };

  useEffect(() => {
    // Clear search text value
    // console.log(countries);
    setNamesData(countries);
  }, [customerCountries]);

  const handleDelete = (e) => {
    e.preventDefault();
    dispatch(setCGState("selCustCountries", []));
    setSelectAll(false);
  };

  const handleInputChange = (value) => {
    setSearchText(value);
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);

    if (!selectAll) {
      if (searchText) {
        let val = countries.filter((name) =>
          name.toLowerCase().includes(searchText.toLowerCase())
        );
        let item = [...selCustCountries, ...val];
        const distinctArray = [...new Set(item)];
        dispatch(setCGState("selCustCountries", distinctArray));
        let itemcount = distinctArray.length - 1;
        setDisplayItem(itemcount);
      } else {
        dispatch(setCGState("selCustCountries", countries));
        let itemcount = countries.length - 1;
        setDisplayItem(itemcount);
      }
    } else {
      if (searchText) {
        let val = countries.filter((name) =>
          name.toLowerCase().includes(searchText.toLowerCase())
        );
        let item = [...selCustCountries];
        item = item.filter((name) => !val.includes(name));
        const distinctArray = [...new Set(item)];
        dispatch(setCGState("selCustCountries", distinctArray));
        let itemcount = distinctArray.length;
        setDisplayItem(itemcount);
      } else {
        dispatch(setCGState("selCustCountries", []));
        let itemcount = 0;
        setDisplayItem(itemcount);
      }
    }
  };

  useEffect(() => {
    let itemcount = selectedOptions.length - 1;
    setDisplayItem(itemcount);
  }, [selectedOptions]);

  useEffect(() => {
    let itemcount = selCustCountries.length - 1;
    setDisplayItem(itemcount);
  }, [selCustCountries]);

  useEffect(() => {
    let item = namesData?.length > 0 ? [...namesData] : [];
    item = item.filter((name) => !selCustCountries.includes(name));
    if (item.length === 0) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [namesData]);

  useEffect(() => {
    //use a debounce to delay the search input key entry
    const delayDebounceFn = setTimeout(() => {
      if (searchText) {
        //filter options state using search text provided
        setNamesData((prevVal) => {
          let val = countries.filter((name) =>
            name.toLowerCase().includes(searchText.toLowerCase())
          );

          return val;
        });
      } else {
        setSearchText();
        setNamesData(countries);
      }

      //set focus on search text input field on load. setTimeOut is added as textInput is not immediately available
      setTimeout(() => {
        if (textInput.current) textInput.current.focus();
      }, 100);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);

  const getProductIdsFromNames = (productNames) => {
    const productIds = productNames.map((name) => {
      const product = customerCountries.find(
        (option) => option.customerName === name
      );
      return product ? product.packGroupOrSKUID : null;
    });
    return productIds.filter((id) => id !== null);
  };

  useEffect(() => {
    if (selCustCountries.length > 0) {
      dispatch(
        setCGState(
          "selectedDataProductIds",
          getProductIdsFromNames(selCustCountries)
        )
      );
      dispatch(setCGState("clearDataValues", false));
    } else {
      dispatch(setCGState("selectedDataProductIds", []));
    }
  }, [selCustCountries]);

  useEffect(() => {
    if (clearDataValues) {
      dispatch(setCGState("selCustCountries", []));
      setSelectAll(false);
      setSearchText("");
    }
  }, [clearDataValues]);

  // console.log(namesData);
  // console.log(selCustCountries);

  return (
    <div>
      <FormControl>
        <InputLabel>Customer Country</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          fullWidth
          sx={{
            // width: "250px !important",
            height: "44px !important",
          }}
          value={selCustCountries}
          size="small"
          input={<OutlinedInput label="Customer Country" />}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }} MenuProps>
              <div>
                {selCustCountries.length === 1 && (
                  <span>{selCustCountries[0]?.substring(0, 15)}</span>
                )}
                {selCustCountries.length > 1 && (
                  <span>
                    {selCustCountries[0]?.substring(0, 15)} + <b>{displayItem}</b>
                  </span>
                )}
                <span>
                  <CancelIcon
                    sx={{
                      paddingLeft: "25px",
                      top: "20%",
                      position: "absolute",
                    }}
                    onMouseDown={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                    }}
                    onClick={(e) => handleDelete(e)}
                  />
                </span>
              </div>
            </Box>
          )}
        >
          <MenuItem onClick={handleSelectAll}>
            <Checkbox checked={selectAll} />
            <ListItemText primary="Select All" />
          </MenuItem>
          <ListSubheader>
            <TextField
              size="small"
              inputRef={textInput}
              placeholder=""
              value={searchText}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  /*close icon to clear the search text*/
                  <InputAdornment position="end">
                    <IconButton onClick={() => setSearchText("")}>
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onChange={(e) => handleInputChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          {namesData?.map((name, index) => {
            // console.log(name, index);
            return (
              <MenuItem key={index + name} value={name}>
                {selectAll ? (
                  <Checkbox
                    onChange={(e) => handleChange(e, name)}
                    checked={selCustCountries.some((o) => o === name)}
                  />
                ) : (
                  <Checkbox
                    onChange={(e) => handleChange(e, name)}
                    checked={selCustCountries.indexOf(name) > -1}
                  />
                )}
                <ListItemText primary={name} />
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </div>
  );
};

export default CreateMultiSelectCustCountry;
